import { createContext, useState, useContext, useEffect } from "react";

export const UserContext = createContext(null);

// Language context
export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const stored = localStorage.getItem("language");
    return stored !== null ? String(stored) : "2"; // default "2"
  });

  // persist
  useEffect(() => {
    localStorage.setItem("language", language);
  }, [language]);

  // apply class to <html> so CSS can switch fonts
  useEffect(() => {
    const prev = Array.from(document.documentElement.classList).filter((c) =>
      c.startsWith("lang-")
    );
    prev.forEach((c) => document.documentElement.classList.remove(c));
    document.documentElement.classList.add(`lang-${language}`);
    return () => {
      document.documentElement.classList.remove(`lang-${language}`);
    };
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

// Custom hook for easier access to LanguageContext
export const useLanguage = () => useContext(LanguageContext);
